import { createApi } from "@reduxjs/toolkit/query/react";

import { COMPANY_MINE, EMPLOYEE_COMPANY_CURRENT } from "@/constants/apiEndpoints";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import type { IMySpaceCompany } from "@/types/(my-space)/companies.interface";
import type { IApiResponse } from "@/types";

export const companiesApi = createApi({
  reducerPath: "companiesApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["getSuperAdminCompanies", "getEmployeeCompanies"],
  endpoints: (builder) => ({
    getCompanyMine: builder.query<IApiResponse<IMySpaceCompany[]>, void>({
      query: () => {
        return {
          url: COMPANY_MINE,
          method: "GET",
        };
      },
      providesTags: ["getSuperAdminCompanies"],
    }),
    getEmployeeCompanyCurrent: builder.query<IApiResponse<IMySpaceCompany[]>, void>({
      query: () => {
        return {
          url: EMPLOYEE_COMPANY_CURRENT,
          method: "GET",
        };
      },
      providesTags: ["getEmployeeCompanies"],
    }),
  }),
});

export const { useGetCompanyMineQuery, useGetEmployeeCompanyCurrentQuery } = companiesApi;
